module.exports = __webpack_public_path__ + "static/media/quan.80a876b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/activity/inviteNew/quan.png
// module id = 1933
// module chunks = 6